exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3k1t_dD8IGi_31PkLJOy4D{padding:20px}.iUf1NVem-bo4wp1seFGpr{font-family:monospace}", ""]);

// exports
exports.locals = {
	"hdxForm": "_3k1t_dD8IGi_31PkLJOy4D",
	"featureSelection": "iUf1NVem-bo4wp1seFGpr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true}!./app/styles/HDXExportRegionForm.css
// module id = 1475
// module chunks = 1